const productsTable = {
	columns: {
		product: "Produto",
		fiscalCode: "SKU",
		category: "Categoria",
		quantity: "Quantidade",
		lastUnitCost: "Último custo",
		avgUnitCost: "Custo médio",
		totalAvgCost: "Custo total",
		actions: {
			seeProductDetails: "Detalhes do produto",
			transferProduct: "Transferir produto",
			removeProduct: "Remover produto",
			ariaLabels: {
				button: "Ações do produto {{productName}}",
				details: "Ver detalhes do produto {{productName}}",
				transfer: "Transferir produto para outro estoque",
				remove: "Remover produto do estoque",
			},
		},
	},
	quantityInput: {
		add: "Adicionar quantidade de {{productName}}",
		remove: "Remover quantidade de {{productName}}",
	},
};

const adjustStorageProductDrawer = {
	input: {
		title: "Adicionar quantidades ao produto",
	},
	remove: {
		title: "Retirar quantidades do produto",
	},
	form: {
		product: "Produto",
		addQuantity: "Quantidade que deseja adicionar",
		removeQuantity: "Quantidade que deseja remover",
		unitCostValue: "Preço de custo",
		validation: {
			quantityMustBeGreaterThanZero: "A quantidade deve ser maior que zero",
			invalidQuantity: "Quantidade inválida",
		},
		actions: {
			cancel: "Cancelar",
			add: "Adicionar Quantidade",
			remove: "Retirar Quantidade",
		},
	},
	notifications: {
		success: {
			input: "Quantidades adicionadas com sucesso",
			remove: "Quantidades removidas com sucesso",
		},
		error: {
			input: "Erro ao adicionar quantidades",
			remove: "Erro ao remover quantidades",
		},
	},
};

export const storageV2 = {
	backButtonLabel: "Voltar para estoques",
	tabs: {
		products: {
			title: "Produtos do estoque",
			header: {
				filters: {
					search: {
						placeholder: "Buscar por produto",
					},
					category: {
						placeholder: "Filtrar por categoria",
						all: "Todas as categorias",
					},
					state: {
						placeholder: "Filtrar por estado de estoque",
						all: "Todos os produtos",
						zero: "Estoque zero",
						negative: "Estoque negativo",
					},
				},
				actions: {
					inventory: "Inventariar estoque",
					inventoryTitle: "Inventariar estoque",
					addProducts: "Adicionar produtos",
					addProductsTitle: "Adicionar produtos ao estoque",
					importXml: "Importar XML",
					importXmlTitle: "Importar XML de nota fiscal de compra",
					importViaExcel: "Importar via Excel",
					importViaExcelTitle: "Importar via Excel",
				},
			},
			totalizers: {
				productsInStock: "Produtos em estoque",
				totalCost: "Valor em estoque",
				productsWithoutCost: "Produtos com custo zerado",
				productsWithoutStock: "Produtos com qtd. zerada",
			},
			table: productsTable,
			adjustStorageProductDrawer,
			transferDrawer: {
				title: "Transferir produto {{productName}} do estoque",
				form: {
					label: {
						product: "Produto",
						fromStorage: "Retirando produtos do estoque",
						toStorage: "Transferindo produtos para o estoque",
						quantity: "Quantidade que deseja transferir",
					},
					placeholder: {
						toStorage: "Selecione o estoque",
					},
					hint: {
						maxQuantity: "Máximo disponível: {{maxQuantity}}",
					},
					sectionTitle: {
						chooseDestination: "Escolha o estoque de destino",
					},
					validation: {
						maxStorageCountIs: "Quantidade máxima em estoque é {{productMaxCountString}}",
						missingField: "Campo obrigatório",
						invalidQuantity: "Quantidade inválida",
					},
				},
				actions: {
					cancel: "Cancelar",
					submit: "Concluir transferência",
				},
				notifications: {
					success: "Transferência concluída com sucesso.",
				},
			},
			removeProductFromStorageDialog: {
				title: "Excluir produto",
				warningMessageSingle:
					"Certeza que deseja excluir o produto {{productName}} do estoque?",
				warningMessageMultiple:
					"Certeza que deseja excluir os {{count}} produtos do estoque?",
				warningMessageStrong: " Essa ação não pode ser desfeita",
				submit: "Excluir produto",
				notifications: {
					success: "Produto excluído do estoque com sucesso.",
				},
			},
			adjustProductUnitCostValue: {
				label: "Atualizar custo unitário de {{productName}}",
				disabledLabel:
					"Custo unitário de {{productName}} não pode ser atualizado, pois produto não possui estoque",
			},
		},
		inventory: {
			title: "Histórico de inventários",
		},
	},
};

export type StorageV2Translations = typeof storageV2;
